import { render, staticRenderFns } from "./SampleClassificationVibration.vue?vue&type=template&id=610dcdba"
import script from "./SampleClassificationVibration.vue?vue&type=script&lang=js"
export * from "./SampleClassificationVibration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports